import { warnDev } from '@/utils/warnDev'

import type { PathType } from '../TableBase.types'
import { getRowId } from './getRowId'

export const getDataWithId = <Data extends Record<string, unknown>, Path extends PathType<Data>>(
  data: Data[] | undefined,
  rowIdProperty: ((data: Data) => string) | Path | undefined
) => {
  if (!data) return []

  const getId = getRowId(rowIdProperty)

  return data.map((row) => {
    const __id = getId(row)

    if ('__id' in row && row.__id !== __id) {
      warnDev(`getDataWithId: Overwriting existing __id "${row.__id}" with new __id "${__id}"`)
    }

    return { ...row, __id }
  })
}
